const MENUS = [
    {
        icon: 'el-icon-document',
        label: 'shareUser',
        path: 'shareListUserChildren',
        meta: {
            permission: []
        },
        pathActive: ['shareListUserChildren', 'dataViewChildren', 'dataViewCreateChildren', 'dataViewDetailChildren', 'dataViewEditChildren', 'dataViewEditMultipleChildren'],
        isDisableForAdmin: true,
        isDisableForUser: false
    },
    {
        icon: 'el-icon-printer',
        label: 'exportUser',
        path: 'exportListUserChildren',
        meta: {
            permission: []
        },
        pathActive: ['exportListUserChildren'],
        isDisableForAdmin: true,
        isDisableForUser: false
    },
    {
        icon: 'el-icon-document',
        label: 'shareManagement',
        path: 'shareList',
        meta: {
            permission: []
        },
        pathActive: [
            'dataLinkMultiList',
            'editDataLinkMulti',
            'viewDataLinkMulti',
            'shareList',
            'shareListUser',
            'addShare',
            'editShare',
            'dataView',
            'dataViewCreate',
            'dataViewDetail',
            'dataViewEdit',
            'dataViewEditMultiple'
        ],
        isDisableForUser: true,
        subMenu: [
            {
                icon: '',
                field: 'pageTaxProperty.field',
                label: 'dataLinkMultiList',
                path: 'dataLinkMultiList',
                meta: {
                    permission: []
                },
                pathActive: [
                    'dataLinkMultiList',
                    'editDataLinkMulti',
                    'viewDataLinkMulti',
                    'dataLinkMultiDataView',
                    'dataLinkMultiDataViewCreate',
                    'dataLinkMultiDataViewDetail',
                    'dataLinkMultiDataViewEdit',
                    'dataLinkMultiDataViewEditMultiple'
                ],
                isDisableForUser: true,
                subMenu: []
            },
            {
                icon: '',
                field: 'pageTaxProperty.field',
                label: 'shareList',
                path: 'shareList',
                meta: {
                    permission: []
                },
                pathActive: ['shareList', 'shareListUser', 'editShare', 'dataView', 'dataViewCreate', 'dataViewDetail', 'dataViewEdit', 'dataViewEditMultiple'],
                isDisableForUser: true,
                subMenu: []
            },
            {
                icon: '',
                field: 'pageTaxProperty.field',
                label: 'addShare',
                path: 'addShare',
                meta: {
                    permission: []
                },
                pathActive: ['addShare'],
                subMenu: [],
                isDisableForUser: true
            }
        ]
    },
    {
        icon: 'el-icon-user',
        label: 'memberManagement',
        path: 'memberList',
        meta: {
            permission: []
        },
        pathActive: ['memberList', 'addMember', 'editMember'],
        isDisableForUser: true,
        subMenu: [
            {
                icon: '',
                label: 'memberList',
                path: 'memberList',
                meta: {
                    permission: []
                },
                pathActive: ['memberList', 'editMember'],
                isDisableForUser: true,
                subMenu: []
            },
            {
                icon: '',
                label: 'memberAdd',
                path: 'addMember',
                meta: {
                    permission: []
                },
                pathActive: ['addMember'],
                isDisableForUser: true,
                subMenu: []
            }
        ]
    },
    {
        icon: 'el-icon-setting',
        label: 'settingKintone',
        path: 'settingKintone',
        meta: {
            permission: []
        },
        pathActive: ['settingKintone'],
        isDisableForUser: true,
        subMenu: []
    },
    {
        icon: 'el-icon-setting',
        label: 'setting',
        path: 'setting',
        meta: {
            permission: []
        },
        pathActive: ['setting'],
        isDisableForUser: true,
        subMenu: []
    },
    {
        icon: 'el-icon-s-promotion',
        label: 'mailInvite',
        path: 'mailInviteList',
        meta: {
            permission: []
        },
        pathActive: ['mailInviteList', 'mailInviteAdd', 'mailInviteEdit'],
        isDisableForUser: true,
        subMenu: [
            {
                icon: '',
                label: 'mailInviteList',
                path: 'mailInviteList',
                meta: {
                    permission: []
                },
                pathActive: ['mailInviteList', 'mailInviteEdit'],
                isDisableForUser: true,
                subMenu: []
            },
            {
                icon: '',
                label: 'mailInviteAdd',
                path: 'mailInviteAdd',
                meta: {
                    permission: []
                },
                pathActive: ['mailInviteAdd'],
                isDisableForUser: true,
                subMenu: []
            }
        ]
    }
];
export { MENUS };
